// removed by extract-text-webpack-plugin
module.exports = {"nf-packaging-info__grid":"nf-packaging-info__grid","rt-table":"rt-table","rt-resizable-header-content":"rt-resizable-header-content","rt-td":"rt-td"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/PackagingInfoGrid/PackagingInfo.scss
// module id = 4977
// module chunks = 1